// eslint-disable-next-line no-unused-vars
const Types = require('../../../../../jsdoc-types');

const { onOnce, addDocumentDelegatedListener, onDOMContentLoaded } = require('../../common/utils/domEvents');
const { getDoubleLookPIDWithoutSize } = require('../../common/utils/doubleLookUtils');
const { BODY_ELEMENTS, LIST_NAMES, PAGE_ACTIONS } = require('../analyticsConst');
const { analyticsEventCenter } = require('../events');
const { oneBasedPosition } = require('../ga4/utils/positionUtils');
const { buildItemListForReferrer, buildItemListForProductTileClick } = require('../helpers/itemListHelpers');
const {
  setCurrentList, impressionItemListStorage, cartItemListStorage, createItemListAndPosition,
} = require('../stores/itemList');

/**
 * When a user clicks on a product card in the save for later section, we get
 * the product ID from the card and update the product list
 * @param {Event} e The event object
 */
function handleSafeForLaterClick(e) {
  const productCard = e.target.closest(BODY_ELEMENTS.sflProductCard);
  const pid = getDoubleLookPIDWithoutSize(productCard?.dataset.productId);
  if (pid) {
    impressionItemListStorage.setItem(pid, LIST_NAMES['save-for-later']);
  }
}

/**
 * When a user clicks on a product card in the wishlist section, we get the
 * product ID from the card and update the product list
 * @param {Event} e The event object
 */
function handleWishlistClick(e) {
  const productCard = e.target.closest(BODY_ELEMENTS.wishlistProductCard);
  const pid = getDoubleLookPIDWithoutSize(productCard?.dataset.productId);
  if (pid) {
    impressionItemListStorage.setItem(pid, LIST_NAMES.wishlist);
  }
}

/**
 * Begin the tracking for gaInfo related data
 */
function beginTracking() {
  /*
   * ItemList tracking for IMPRESSIONS
  \* ------------------------------------------------------------------------ */
  setCurrentList(buildItemListForReferrer());

  onDOMContentLoaded(() => {
    const page = document.querySelector('.page');
    const isHome = page?.dataset.action === PAGE_ACTIONS.home;
    if (isHome) {
      setCurrentList(LIST_NAMES.home);
    }
  });

  addDocumentDelegatedListener(
    'click',
    BODY_ELEMENTS.sflProductCardLinks,
    handleSafeForLaterClick,
  );
  addDocumentDelegatedListener(
    'click',
    BODY_ELEMENTS.wishlistProductCardLinks,
    handleWishlistClick,
  );

  onOnce(window, 'beforeunload', () => {
    document.removeEventListener('click', handleSafeForLaterClick);
    document.removeEventListener('click', handleWishlistClick);
  });

  analyticsEventCenter.subscribe(
    analyticsEventCenter.EVENTS.productTileClicked,
    (payload) => {
      /** @type {{ location: string, product: Types.FullProduct }} */
      const { location, product } = payload;
      const itemList = buildItemListForProductTileClick(
        location,
        product.parentCategoryName,
      );
      const pid = getDoubleLookPIDWithoutSize(product.id);
      impressionItemListStorage.setItem(pid, itemList);
    },
    {
      synchronous: true,
    },
  );

  /*
   * ItemList tracking for CART items
  \* ------------------------------------------------------------------------ */
  analyticsEventCenter.subscribe(
    analyticsEventCenter.EVENTS.productAddedToCart,
    ({ list, position, product }) => {
      cartItemListStorage.setItem(
        product.id,
        createItemListAndPosition(list, oneBasedPosition(position)),
      );
    },
  );
}

module.exports = {
  beginTracking,
};
